import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AnnoncesPremium from './annoncePremium';
import OffresPremium from './OffrePremium';
import ProprietairesPremium from './OwnerPremium';
import EnvoyerMail from '../../Components/Email/message';
import { MyContext } from '../../Components/Context';

const Premium = () => {
  const [selectedTab, setSelectedTab] = useState('annonces');
    const { actifItem, setActifItem } = useContext(MyContext);


    useEffect(()=>{
        setActifItem('Premiums')
    }, [])
  
  return (
    <div className="p-6 mx-5 transition duration-300 ease-in-out bg-white rounded-lg shadow-lg dark:bg-gray-800">
      {/* Tabs de navigation */}
      <div className="flex mb-4 space-x-4">
        <button
          onClick={() => setSelectedTab('annonces')}
          className={`px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${
            selectedTab === 'annonces' ? 'bg-indigo-600 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          Annonces Premium
        </button>
        <button
          onClick={() => setSelectedTab('offres')}
          className={`px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${
            selectedTab === 'offres' ? 'bg-indigo-600 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          Offres Premium
        </button>
        <button
          onClick={() => setSelectedTab('proprietaires')}
          className={`px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${
            selectedTab === 'proprietaires' ? 'bg-indigo-600 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          Propriétaires Premium
        </button>
      </div>

      {/* Contenu des Tabs */}
      <div className="p-4 transition duration-500 ease-in-out rounded-md bg-gray-50 dark:bg-gray-700">
        {selectedTab === 'annonces' && <AnnoncesPremium />}
        {selectedTab === 'offres' && <OffresPremium />}
        {selectedTab === 'proprietaires' && <ProprietairesPremium />}
        {selectedTab === 'mails' && <EnvoyerMail />}
      </div>
    </div>

  );
};

// Composant pour voir les annonces premium

    
    



// Composant pour voir et gérer les propriétaires premium


// Composant pour envoyer un mail


export default Premium;
